/**
 * Links to AileFX's other apps. Each is a separate deployment whose address is
 * a build-time property of the environment (`VITE_*`), never something the
 * deployment descriptor says. A value that is not an http(s) URL counts as
 * unset, and the link is left out rather than pointing somewhere broken.
 */

function httpUrl(value: string | undefined): string | null {
  if (value === undefined || value.trim() === "") return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "https:" || url.protocol === "http:" ? url.toString().replace(/\/$/, "") : null;
  } catch {
    return null;
  }
}

/** The client portal, where customers (companies that are not market makers) sign in; null when unset. */
export function getPortalUrl(): string | null {
  return httpUrl(import.meta.env.VITE_PORTAL_URL);
}
